import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import DownloadIcon from "@mui/icons-material/Download";
import { styled } from "@mui/material/styles";
import ReactCardFlip from "react-card-flip";

import top100Image from "../../images/Top100Screenshot.png";
import fixitImage from "../../images/FIXiTScreenshot.jpg";
import roadImage from "../../images/RoadScreenshot.png";
import mpoImage from "../../images/MPOScreenshot.png";
import mpoPresentationImage from "../../images/ILMATPresentationImage.jpg"
import userGuideImage from "../../images/ILMATUserGuideScreenshot.jpg"
import "../../styles/HomeTabs.css";

// From 'Tabs (Introduction)' MUI example (https://mui.com/material-ui/react-tabs/#introduction)

const CardButton = styled(Button)({
  backgroundColor: "#002768",
  color: "white",
  padding: "10px",
  fontWeight: 700,
  margin: "-5px 0px 5px 5px",
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ marginTop: "20px", fontWeight: 700 }}>{children}</Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// function accessibilityProps(index) {
//   return {
//     id: `simple-tab-${index}`,
//     'aria-controls': `simple-tabpanel-${index}`,
//   };
// }

export default function HomeTabs() {
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [flippedStates, setFlippedStates] = useState([
    false,
    false,
    false,
    false,
  ]);
  const handleFlipCard = (index) => {
    const newFlippedStates = [...flippedStates];
    newFlippedStates[index] = !newFlippedStates[index];
    setFlippedStates(newFlippedStates);
  };

  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  return (
    <Box>
      <Tabs
        variant="fullWidth"
        value={value}
        onChange={handleChange}
        aria-label="home tabs"
        sx={{
          backgroundColor:
            theme.palette.mode === "light"
              ? "#efefef"
              : theme.palette.background.default,
        }}
      >
        <Tab
          label="Overview"
          id="Overview"
          aria-controls="tabpanel-overview"
          sx={{ fontWeight: 700 }}
        />
        <Tab
          label="Training/User Guides"
          id="TrainingUserGuides"
          aria-controls="tabpanel-training-user-guides"
          sx={{ fontWeight: 700 }}
        />
        <Tab
          label="Other Resources"
          id="OtherResources"
          aria-controls="tabpanel-other-resources"
          sx={{ fontWeight: 700 }}
        />
        {/* <Tab label="Use Cases" id="UseCases" aria-controls='tabpanel-use-cases' sx={{ fontWeight: 700 }} /> */}
        {/* <Tab label="User Group" id="UserGroup" aria-controls='tabpanel-user-group' sx={{ fontWeight: 700 }} /> */}
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <Grid container spacing={2} justifyContent="flex-start" sx={{  paddingLeft: 2, paddingRight: 2, width: "100%", maxWidth: "1600px", margin: "0 auto", paddingBottom: 2 }}>
          <Grid item>
            <ReactCardFlip
              isFlipped={flippedStates[0]}
              flipDirection="horizontal"
            >
              <Card sx={{ maxWidth: 500, margin: "auto" }}>
                <CardMedia
                  sx={{ height: 200 }}
                  image={roadImage}
                  title="Road"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontWeight: 700, textAlign: "left" }}
                  >
                    Roads Module
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ textAlign: "justify", height: 150 }}
                  >
                    The roads module provides access to mobility performance
                    measures at the road segment level covering the majority of
                    the major roads in the Illinois state roadway system. In
                    addition to the individual road segment level, user’s can
                    generate custom corridor summaries and various summary
                    reports (functional classification, district, MPO,
                    rural/urban, etc.). The roadway performance measures are
                    based on a combination of traffic volumes from IDOT and
                    proprietary speed data from HERE.
                  </Typography>
                </CardContent>
                <CardActions>
                  <CardButton size="small" href="/roads">
                    Open
                  </CardButton>
                  <CardButton size="small" onClick={() => handleFlipCard(0)}>
                    LEARN MORE
                  </CardButton>
                </CardActions>
              </Card>

              <Card sx={{ maxWidth: 500 }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 700, textAlign: "left" }}
                  >
                    Roads Module
                  </Typography>
                  <p style={{ textAlign: "left", paddingBottom: "0px" }}>
                    Features
                  </p>
                  <ul className="feature-list">
                    <li>
                      Typical roadway performance measures at road segment
                      level, including annual delay, travel time index (TTI),
                      planning time index (PTI) – 80th percentile, PTI – 95th
                      percentile, peak period values, traffic volume (AADT),
                      vehicle miles of travel (VMT), congested speed, reference
                      speed.
                    </li>
                    <li>Both all vehicle and trucks as separate values.</li>
                    <li>
                      Summaries by geographic (i.e., district, county) and road
                      characteristic (i.e., route, functional class, rural/uban,
                      National Highway System, freight network, etc.)
                    </li>
                    <li>
                      Ability to create custom corridors on the go using push
                      pins.
                    </li>
                    <li>
                      Multiple years of data that would allow for a trends
                      analysis.
                    </li>
                  </ul>
                </CardContent>
                <CardActions>
                  <CardButton size="small" onClick={() => handleFlipCard(0)}>
                    BACK
                  </CardButton>
                </CardActions>
              </Card>
            </ReactCardFlip>
          </Grid>
          <Grid item>
            <ReactCardFlip
              isFlipped={flippedStates[1]}
              flipDirection="horizontal"
            >
              <Card sx={{ maxWidth: 500, margin: "auto" }}>
                <CardMedia
                  sx={{ height: 200 }}
                  image={top100Image}
                  title="Road"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontWeight: 700, textAlign: "left" }}
                  >
                    Top 100
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ textAlign: "justify", height: 150 }}
                  >
                    The Top 100 Most Congested Road Segments (Top 100) is an
                    annual ranked list of the most congested road segments in
                    Illinois. The primary measure used in ranking the road
                    segments is delay per mile, which quantifies how much
                    additional time it takes to travel a mile on a road than it
                    does to travel that same mile of road during uncongested
                    conditions. Most of the interstates, freeways, arterials,
                    and collectors with high traffic volumes are included in the
                    analysis to produce this list.
                  </Typography>
                </CardContent>
                <CardActions>
                  <CardButton size="small">Coming soon...</CardButton>
                  <CardButton size="small" onClick={() => handleFlipCard(1)}>
                    LEARN MORE
                  </CardButton>
                </CardActions>
              </Card>
              <Card sx={{ width: 500 }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 700, textAlign: "left" }}
                  >
                    Top 100
                  </Typography>
                  <p style={{ textAlign: "left", paddingBottom: "0px" }}>
                    Features
                  </p>
                  <ul className="feature-list">
                    <li>Coming soon</li>
                  </ul>
                </CardContent>
                <CardActions>
                  <CardButton size="small" onClick={() => handleFlipCard(1)}>
                    BACK
                  </CardButton>
                </CardActions>
              </Card>
            </ReactCardFlip>
          </Grid>
          <Grid item>
            <ReactCardFlip
              isFlipped={flippedStates[2]}
              flipDirection="horizontal"
            >
              <Card sx={{ maxWidth: 500, margin: "auto" }}>
                <CardMedia
                  sx={{ height: 200 }}
                  image={fixitImage}
                  title="FIXiT"
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontWeight: 700, textAlign: "left" }}
                  >
                    FIXiT
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ textAlign: "justify", height: 150 }}
                  >
                    Future Improvement Examination Technique (FIXiT) uses
                    high-level inputs such as facility type, posted speed, speed
                    profile, truck percentage, and Average Annual Daily Traffic
                    Volumes, to evaluate facility performance and delay costs
                    for before and after project scenarios. Performance measures
                    evaluated include annual hours of delay (person hours), peak
                    period annual hours of delay (person hours), CO2, wasted
                    fuel, and cost of delay. These measures are calculated for
                    all vehicles, trucks, and passenger vehicles.
                  </Typography>
                </CardContent>
                <CardActions>
                  <CardButton
                    size="small"
                    onClick={() =>
                      window.open(
                        "https://fixit.tti.tamu.edu/dashboard",
                        "_blank"
                      )
                    }
                  >
                    OPEN
                  </CardButton>
                  <CardButton size="small" onClick={() => handleFlipCard(2)}>
                    LEARN MORE
                  </CardButton>
                </CardActions>
              </Card>

              <Card sx={{ width: 500 }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 700, textAlign: "left" }}
                  >
                    FIXiT
                  </Typography>
                  <p style={{ textAlign: "left", paddingBottom: "0px" }}>
                    Features
                  </p>
                  <ul className="feature-list">
                    <li>Coming soon</li>
                  </ul>
                </CardContent>
                <CardActions>
                  <CardButton size="small" onClick={() => handleFlipCard(2)}>
                    BACK
                  </CardButton>
                </CardActions>
              </Card>
            </ReactCardFlip>
          </Grid>
          <Grid item>
            <ReactCardFlip
              isFlipped={flippedStates[3]}
              flipDirection="horizontal"
            >
              <Card sx={{ maxWidth: 500, margin: "auto", height: 500 }}>
                <CardMedia sx={{ height: 180 }} image={mpoImage} title="MPO" />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontWeight: 700, textAlign: "left" }}
                  >
                    MPO Module
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ textAlign: "justify", height: 190 }}
                  >
                    The MPO module is designed with Metropolitan Planning
                    Organizations (MPO) and the congestion management plan (CMP)
                    in mind. An MPO can submit their CMP network and it will be
                    stored in ILMAT, providing easier access to mobility
                    performance measures aggregated to match the CMP network at
                    the click of a button. As with the Roads Module, the MPO
                    module provides access to mobility performance measures at
                    the road segment level and various summary reports
                    (functional classification, district, MPO, rural/urban,
                    etc.). The roadway performance measures are based on a
                    combination of traffic volumes from IDOT and proprietary
                    speed data from HERE.
                  </Typography>
                </CardContent>
                <CardActions>
                  <CardButton size="small" href="/mpo">
                    Open
                  </CardButton>
                  <CardButton size="small" onClick={() => handleFlipCard(3)}>
                    LEARN MORE
                  </CardButton>
                </CardActions>
              </Card>

              <Card sx={{ maxWidth: 500 }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    style={{ fontWeight: 700, textAlign: "left" }}
                  >
                    MPO Module
                  </Typography>
                  <p style={{ textAlign: "left", paddingBottom: "0px", height:2 }}>
                    Features
                  </p>
                  <ul className="feature-list">
                    <li>
                      CMP network can be submitted to ILMAT and stored for easy
                      recall. Roadway performance measures at the road segment
                      level are aggregated to match the CMP network.
                    </li>
                    <li>
                      Typical roadway performance measures at road segment
                      level, including annual delay, travel time index (TTI),
                      planning time index (PTI) – 80th percentile, PTI – 95th
                      percentile, peak period values, traffic volume (AADT),
                      vehicle miles of travel (VMT), congested speed, reference
                      speed.
                    </li>
                    <li>Both all vehicle and trucks as separate values.</li>
                    <li>
                      Summaries by geographic (i.e., district, county) and road
                      characteristic (i.e., route, functional class, rural/uban,
                      National Highway System, freight network, etc.)
                    </li>
                    <li>
                      Ability to create custom corridors on the go using push
                      pins.
                    </li>
                    <li>
                      Multiple years of data that would allow for a trends
                      analysis.
                    </li>
                  </ul>
                </CardContent>
                <CardActions>
                  <CardButton size="small" onClick={() => handleFlipCard(3)}>
                    BACK
                  </CardButton>
                </CardActions>
              </Card>
            </ReactCardFlip>
          </Grid>
        </Grid>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <Grid container spacing={2} sx={{  paddingLeft: 2, paddingRight: 2, width: "100%", maxWidth: "1600px", margin: "0 auto", paddingBottom: 2 }}>
          <Grid item>
            <Card sx={{ width: 500, margin: "auto" }}>
              <CardMedia sx={{ height: 200 }} image={mpoPresentationImage} title="MPO Presentation Image" />
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ fontWeight: 700, textAlign: "left" }}
                >
                  ILMAT Demo Presentation
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ textAlign: "justify" }}
                >
                  April 28th, 2025
                </Typography>
              </CardContent>
              <CardActions>
                <CardButton startIcon={<DownloadIcon />} size="small" href={`${process.env.PUBLIC_URL}/ILMATMPOPresentation04282025.pptx`}>
                  Download Presentation
                </CardButton>
                <a href={`${process.env.PUBLIC_URL}/ILMATMPOPresentation04282025.pdf`} target='_blank' rel='noopener noreferrer'>
                  <CardButton startIcon={<DownloadIcon />} size="small">
                    Download PDF
                  </CardButton>
                </a>
              </CardActions>
            </Card>
          </Grid>
          <Grid item>
          <Card sx={{ width: 500, margin: "auto" }}>
              <CardMedia sx={{ height: 200 }} image={userGuideImage} title="User Guide" />
              <CardContent>
                <Typography
                  gutterBottom
                  variant="h5"
                  component="div"
                  style={{ fontWeight: 700, textAlign: "left" }}
                >
                  User Guide
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ textAlign: "justify" }}
                >
                  May 2nd, 2025
                </Typography>
              </CardContent>
              <CardActions>
                <a href={`${process.env.PUBLIC_URL}/ILMATUsersGuide.pdf`} target='_blank' rel='noopener noreferrer'>
                  <CardButton startIcon={<DownloadIcon />} size="small" color='inherit'>
                    Download PDF
                  </CardButton>
                </a>
              </CardActions>
            </Card>
          </Grid>
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Grid
          container
          spacing={2}
          direction="column"
          sx={{ textAlign: "left", pl: 2 }}
        >
          <Grid item>
            <Typography variant="body1">
              <a
                href="https://idot.illinois.gov/transportation-system/network-overview/highway-system.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                IDOT Highway System
              </a>
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1">
              <a
                href="https://idot.illinois.gov/transportation-system/network-overview/highway-system/interactive-data-tools.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                Interactive Data Tools
              </a>
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1">
              <a
                href="https://webapps1.dot.illinois.gov/IROADS/"
                target="_blank"
                rel="noopener noreferrer"
              >
                IROADS
              </a>
              : Illinois Roadway Analysis Database System is a graphical
              application providing access to current and planned projects,
              roadway attributes, bridge inventory information, and pavement
              condition images.
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1">
              <a
                href="https://www.gettingaroundillinois.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Getting Around Illinois
              </a>
              : web-based interactive mapping site that provides the ability to
              search and display several sources of transportation data. You can
              find information on winter road conditions, annual average daily
              traffic, road construction, trucking routes, and planned road
              projects. Click on the images below to begin your search.
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1">
              <a
                href="https://idot.illinois.gov/transportation-system/network-overview/highway-system/manuals.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                Manuals
              </a>
            </Typography>
          </Grid>
        </Grid>
      </CustomTabPanel>
      {/* <CustomTabPanel value={value} index={4}>
      USE CASES
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
      USER GROUP
      </CustomTabPanel> */}
    </Box>
  );
}
